import * as React from 'react';

import { Translate } from '@decorators';

import { SharePage } from '@common/components/SharePage';
import { withShareTrackContainer } from '@common/containers/Share/ShareTrack';

import { IShareAlbumProps } from './types';

@Translate('containers.Share.ShareTrack')
class ShareTrackContainer extends React.Component<IShareAlbumProps> {

	render() {
		const {
			track,
			description,
		} = this.props;

		return track
			? (
				<SharePage
					gradientColor={track?.cover?.avgColor}
					entityName={this.t('entity')}
					pictureUrl={track?.cover?.url}
					title={track.name}
					description={description}
					audioUrl={track?.file}
				/>
			)
			: null;
	}

}

export const ShareTrack = withShareTrackContainer(ShareTrackContainer);
